import { createFileRoute, Outlet } from "@tanstack/react-router";

import MainLayout from "@/layouts/main/MainLayout";

export const Route = createFileRoute("/_secure/_main")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
}
